import React from 'react';
import { Form } from 'react-form';
import PropTypes from 'prop-types';

import { Input } from '../../../components/Form';
import Img from '../../../components/Img';
import TennisAustraliaLogin from '../../../components/TennisAustraliaLogin';

import { createReactFormValidator, requiredEmail } from '../../../utils/validation';
import { useStatsig } from '../../../components/hooks/useStatsig';
import { SocialAuthProviders } from './utils';
import styles from '../Login/login.scss';
import config from '../../../../config';

const SignInStep = ({ onContinueClick, isSubmitting, email, handleLoginWithSocial }) => {
    const { APPLE, FACEBOOK } = SocialAuthProviders;
    const { checkGate, featureGates } = useStatsig();
    const appleSignInEnabled = checkGate(featureGates.APPLE_OAUTH_V3);
    const defaultValues = {
        email: email || '',
    };

    const renderSocialAuthButton = (provider) => {
        let imageSrc = '';

        if (provider === APPLE) {
            imageSrc = '/img/v4/icon-apple-login.svg';
        } else if (provider === FACEBOOK) {
            imageSrc = '/img/v4/icon-facebook-login.svg';
        }

        return (
            <button
                type="button"
                onClick={() => handleLoginWithSocial(provider)}
                className={styles.magicLinkSocialButton}
                data-testid={`magic-link-login.sign-in-step.${provider.toLowerCase()}-social-btn`}
            >
                <Img src={imageSrc} data-testid={`magic-link-login.sign-in-step.${provider.toLowerCase()}-social-icon`} />
            </button>
        );
    };

    return (
        <div>
            <p className={`${styles.magicLinkText}`} data-testid="magic-link-login.sign-in-step.title">
                Sign in with Email
            </p>
            <Form
                onSubmit={(values) => onContinueClick(values)}
                defaultValues={defaultValues}
            >
                {(formApi) => {
                    const { submitForm } = formApi;
                    const handleFormSubmit = (event) => {
                        event.preventDefault();
                        submitForm();
                    };
                    return (
                        <form onSubmit={handleFormSubmit} data-testid="magic-link-login.sign-in-step.form">
                            <Input
                                id={`emailInput`}
                                field={`email`}
                                label="Email"
                                validate={createReactFormValidator(requiredEmail)}
                                hiddenLabel={true}
                                disableProfanityCheck={true}
                                themeV3
                                data-testid="magic-link-login.sign-in-step.email-input"
                            />

                            <div>
                                <button
                                    type="submit"
                                    className={`btn btn-primary btn-xl btn-block fw600`}
                                    disabled={isSubmitting}
                                    data-testid="magic-link-login.sign-in-step.continue-btn"
                                >
                                    CONTINUE
                                </button>
                            </div>
                        </form>
                    );
                }}
            </Form>
            <div className={`${styles.tos} mb-1`}>
                <span data-testid="magic-link-login.sign-in-step.tos">By continuing, I agree to the <a href={`${config.marketingAppHost}/tos`} target="_blank" rel="noopener noreferrer" data-testid="magic-link-login.sign-in-step.tos-link">Terms of service</a>.</span>
            </div>
            <div className={'mt32 mb32'}>
                <p className={styles.magicLinkText} data-testid="magic-link-login.sign-in-step.social-heading">Or continue with</p>
                <div className={styles.socialAuthButtonsContainer}>
                    {appleSignInEnabled && renderSocialAuthButton(APPLE)}
                    {renderSocialAuthButton(FACEBOOK)}
                    <TennisAustraliaLogin showUpdatedButton={true} />
                </div>
            </div>
        </div>
    );
};

SignInStep.propTypes = {
    onContinueClick: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool,
    email: PropTypes.string,
    handleLoginWithSocial: PropTypes.func.isRequired,
};

SignInStep.defaultProps = {
    isSubmitting: false,
    email: '',
};

export default SignInStep;
